import React from "react";
import { useParams } from "react-router-dom";
import {
  privacyPolicyEmail,
  privacyPolicyList,
} from "../const/privacyConstants";

function PrivacyPolicy() {
  const { appKey } = useParams();

  return (
    <div>
      <h3>Privacy Policy for {privacyPolicyList[appKey].name}</h3>
      <ul>
        {privacyPolicyList[appKey].policies.map((policy) => (
          <li>{policy}</li>
        ))}
      </ul>
      For any query, please feel free to contact at{" "}
      <a href={"mailto:" + privacyPolicyEmail}>{privacyPolicyEmail}</a>
    </div>
  );
}

export default PrivacyPolicy;
